import type { ApiRoute, NoBody, NoQueryParams } from "../../../api"
import type { ListingDescriptionEditView } from "../../../common/listingDescription/ListingDescriptionEditView"

export interface GetListingDescriptionEditViewPathParams {
	inventoryId: string
}

export const getListingDescriptionEditViewRoute: ApiRoute<
	GetListingDescriptionEditViewPathParams,
	NoQueryParams,
	NoBody,
	ListingDescriptionEditView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/listing-description-edit`,
	method: "get",
	path: "/vehicles/:inventoryId/listing-description-edit",
}
